Ext.define('ViewSterownikiBasicStdMobile', {
    extend: 'Ext.panel.Panel',
    grid: null,
    windowObject: null,
    id: "sterowniki",
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyName: "access.manage.sterowniki",
        accessPropertyViewName: "access.view.sterowniki"
    },
    cat: "k",
    text: Lang.sterowniki,
    buttonIconCls: "iconSterownik",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            itemId: 'kontekstfirmy-container',
            xtype: 'container',
            region: 'north',
            hidden: !(AppFIRMACTX != null),
            style: 'background-color: white',
            items: [{
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                cls: "kontekstfirmy-text kontekstfirmy-text-high kontekstfirmy-text-mobile"
            }]
        }, {
            region: "north",
            xtype: 'toolbar',
            scrollable: 'x',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy.capitalise(),
                handler: this.dodajObiekt,
                scope: this,
                disabled: !validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/add"),
                hidden: Const.CLOUDFLAG,
                cls: 'x-btn-mobile'
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.rejestruj.capitalise(),
                handler: this.rejestrujObiekt,
                scope: this,
                disabled: !validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/add"),
                hidden: !Const.CLOUDFLAG || Const.AGGREGATEDCORE,
                cls: 'x-btn-mobile'
            }, {
                id: this.id + "bedit",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.edytuj.capitalise(),
                scope: this,
                handler: this.edytujObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/update"),
                hidden: Const.AGGREGATEDCORE,
                cls: 'x-btn-mobile'
            }, {
                id: this.id + "bdelete",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconDelete",
                text: Lang.usun.capitalise(),
                scope: this,
                handler: this.usunObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/delete"),
                hidden: Const.AGGREGATEDCORE,
                cls: 'x-btn-mobile'
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        if (AppFIRMACTX != null) {
            kontekstfirmy.setText(AppFIRMACTX.nazwa);
        } else {
            kontekstfirmy.setText("");
        }
        this.down('#kontekstfirmy-container').setHidden(!(AppFIRMACTX != null));
        if (this.rebuildGrid) {
            this.rebuildGrid = false;
            var onwer = this.grid.ownerCt;
            Ext.suspendLayouts();
            onwer.remove(this.grid);
            this.grid.destroy();
            this.buildGrid();
            onwer.add(this.grid);
            Ext.resumeLayouts(true);
            if (this.grid && this.grid.rendered)
                if (this.grid.getDockedComponent(1))
                    this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        }
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
    },
    buildGrid: function (datals) {
        this.grid = new Ext.ux.grid.GridPanelExd({
            features: [{
                ftype: 'grouping'
            }],
            plugins: {
                gridfilters: true,
                rowexpander: {
                    rowBodyTpl: new Ext.XTemplate(
                        `<div class="mobile-rowexp-wrapper">

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.nazwa}:
                                <span class="mobile-rowexp-value"> {nazwadsp}</span>
                            </span>
                        </div>

                        <tpl if="serialnumber != null">
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.numer_seryjny}:
                                    <span class="mobile-rowexp-value"> {serialnumber}</span>
                                </span>
                            </div>
                        </tpl>

                        <tpl if="this.notEmptyAfterTrim(opis)">
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.opis}:
                                    <span class="mobile-rowexp-value"> {opis}</span>
                                </span>
                            </div>
                        </tpl>

                        <tpl if="plyn != null">
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.plyn}:
                                    <span class="mobile-rowexp-value"> {plyn}</span>
                                </span>
                            </div>
                        </tpl>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.stanzbiornika}:
                                <span class="mobile-rowexp-value"> {stanzbiornika:this.roundToPrecision}</span>
                            </span>
                        </div>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.pojemnosc}:
                                <span class="mobile-rowexp-value"> {pojemnosc:this.roundToPrecision}</span>
                            </span>
                        </div>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.stanalarmowy}:
                                <span class="mobile-rowexp-value"> {stanalarmowy:this.roundToPrecision}</span>
                            </span>
                        </div>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.stanblokady}:
                                <span class="mobile-rowexp-value"> {stanblokady:this.roundToPrecision}</span>
                            </span>
                        </div>

                        <tpl if="version != null">
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.wersja}:
                                    <span class="mobile-rowexp-value"> {version}</span>
                                </span>
                            </div>
                        </tpl>

                        <tpl if="this.notEmptyAfterTrim(stateopis)">
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.stan}:
                                    <span class="mobile-rowexp-value"> {stateopis}</span>
                                </span>
                            </div>
                        </tpl>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.komunikacja}:</span>
                            {iscommunicationok:this.yesNo}
                        </div>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.typ}:
                                <span class="mobile-rowexp-value"> {tconnect:this.typ}</span>
                            </span>
                        </div>

                        <div class="mobile-rowexp-row">
                            <span class="mobile-rowexp-title">${Lang.active}:</span>
                            {active:this.yesNo}
                        </div>

                        </div>
                        `,
                        {
                            yesNo: renderBool4,
                            roundToPrecision: function (v) {
                                if (v == null)
                                    return null;
                                return Ext.Number.roundToPrecision(v, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
                            },
                            typ: function (v) {
                                return LangComp.typy_podlaczen[v];
                            },
                            notEmptyAfterTrim
                        }
                    )
                }
            },
            store: new Ext.data.Store({
                proxy: new Ext.data.MemoryProxy(),
                autoLoad: true,
                groupField: 'tconnect',
                sorters: [{
                    property: 'nazwa',
                    direction: "ASC"
                }],
                model: Ext.define(null, {
                    extend: 'Ext.data.Model',
                    idProperty: 'id',
                    fields: [{
                        name: 'id',
                        mapping: 'id'
                    }, {
                        name: 'serialnumber',
                        mapping: 'serialnumber'
                    }, {
                        name: 'nazwadsp',
                        mapping: 'nazwadsp'
                    }, {
                        name: 'opis',
                        mapping: 'opis'
                    }, {
                        name: 'version',
                        mapping: 'version'
                    }, {
                        name: 'devid',
                        mapping: 'devid'
                    }, {
                        name: 'active',
                        mapping: 'active'
                    }, {
                        name: 'tconnect',
                        mapping: 'tconnect'
                    }, {
                        name: 'iscommunicationok',
                        mapping: 'iscommunicationok'
                    }, {
                        name: 'stateopis',
                        mapping: 'stateopis'
                    }, {
                        name: 'plyn',
                        mapping: 'plyn',
                        convert: function (d) {
                            return d && d.nazwa;
                        }
                    }, {
                        name: 'stanzbiornika',
                        type: 'float',
                        mapping: 'stanzbiornika'
                    }, {
                        name: 'pojemnosc',
                        type: 'float',
                        mapping: 'pojemnosc'
                    }, {
                        name: 'stanalarmowy',
                        type: 'float',
                        mapping: 'stanalarmowy'
                    }, {
                        name: 'stanblokady',
                        type: 'float',
                        mapping: 'stanblokady'
                    }]
                }),
                reader: new Ext.data.ArrayReader()
            }),
            columns: [{
                header: "ID",
                flex: 1,
                sortable: true,
                dataIndex: 'id',
                filter: {
                    type: 'numeric'
                },
                filterable: true,
                hidden: true
            }, {
                header: Lang.nazwa,
                flex: 2,
                sortable: true,
                dataIndex: 'nazwadsp',
                filter: {
                    type: 'string'
                },
                sorter: Ext.bind(customSorterForGrid, this, ["nazwadsp"], true),
                filterable: true
            }, {
                header: Lang.stan,
                flex: 3,
                sortable: true,
                dataIndex: 'stateopis',
                filter: {
                    type: 'string'
                },
                filterable: true
            }, {
                header: Lang.typ,
                flex: 2,
                sortable: true,
                dataIndex: 'tconnect',
                renderer: function (v) {
                    return LangComp.typy_podlaczen[v];
                },
                filterable: true,
                filter: {
                    type: 'list',
                    options: [[Const.STEROWNIK_CONNECT_NO, Lang.niepodlaczony], [Const.STEROWNIK_CONNECT_USB, Lang.podlaczony_usb], [Const.STEROWNIK_CONNECT_GSM, Lang.podlaczony_gsm]]
                },
                hidden: true
            }],
            frame: false,
            border: false,
            stateId: "grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            }
        });
        this.grid.addListener("rowdblclick", function () {
            if (validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/update"))
                this.edytujObiekt();
        }, this);
        this.grid.addListener("render", function () {
            this.manageSelect(this.grid.getSelectionModel());
        }, this);
        this.grid.addListener("select", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.grid.addListener("selectionchange", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        var bdelete = Ext.getCmp(this.id + "bdelete");
        if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
            bdelete.setDisabled(true);
            bedit.setDisabled(true);
        } else {
            var row = this.grid.getSelectionModel().getSelection()[0];
            bdelete.setDisabled(!validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/delete"));
            bedit.setDisabled(!validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/update"));
        }
    },
    refreshDatastore: function () {
        updateCzasRefreshSerwer();
        if (this.grid && this.grid.rendered)
            this.grid.mask();
        sendAjaxDataJsonRpcL("rest/sterowniki/getJointList", null, this, function (data) {
            if (this.grid && this.grid.rendered)
                this.grid.unmask();
            if (data.status) {
                this.grid.store.loadData(data.data);
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    dodajObiekt: function () {
        this.windowObject = Ext.create('WindowSterownikiBasicStd', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.showW(0);
    },
    rejestrujObiekt: function () {
        this.windowObject = Ext.create('WindowRejestrujSterowniki', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.show();
    },
    edytujObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        this.windowObject = Ext.create('WindowSterownikiBasicStd', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.showW(id);
    },
    usunObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        Ext.MessageBox.show({
            title: Lang.usuwanie,
            msg: Lang.czy_napewno_usunac_obiekt,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "yes") {
                    sendAjaxDataJsonRpcL("rest/sterowniki/deleteJointObject", {
                        id: id
                    }, this, function (data) {
                        if (data.status) {
                        } else {
                            Ext.MessageBox.alert(Lang.error, data.error);
                        }
                        this.refreshDatastore();
                    });
                }
            }
        });
    }
});
